import { OnInit } from '@angular/core';
import { MatDialogRef, MatDialog } from '@angular/material';
import { FormBuilder, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { MainService } from './../_services/main.service';
import { FlashMessagesService } from 'angular2-flash-messages';
var PhoneVerificationComponent = /** @class */ (function () {
    function PhoneVerificationComponent(dialogRef, spinner, formBuilder, dialog, _appService, _flashMessagesService, data) {
        this.dialogRef = dialogRef;
        this.spinner = spinner;
        this.formBuilder = formBuilder;
        this.dialog = dialog;
        this._appService = _appService;
        this._flashMessagesService = _flashMessagesService;
        this.data = data;
        this.submitted = false;
        this.validFormat = true;
        this.otpSent = false;
        this.countDown = 0;
        this.timer = null;
        this.phoneNumber = (data.phoneNumber != null) ? data.phoneNumber : '';
    }
    PhoneVerificationComponent.prototype.ngOnInit = function () {
        this.sendOTPForm = this.formBuilder.group({
            phone_number: [this.phoneNumber, [Validators.required, Validators.minLength(12), Validators.maxLength(12)]]
        });
        this.verifyOTPForm = this.formBuilder.group({
            phone_number: ['', [Validators.minLength(10), Validators.maxLength(12)]],
            otp: ['', Validators.required]
        });
        if (this.phoneNumber) {
            this.onSendOTPSubmit();
        }
    };
    Object.defineProperty(PhoneVerificationComponent.prototype, "fSendOTP", {
        // convenience getter for easy access to form fields
        get: function () { return this.sendOTPForm.controls; },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(PhoneVerificationComponent.prototype, "fVerifyOTP", {
        get: function () { return this.verifyOTPForm.controls; },
        enumerable: true,
        configurable: true
    });
    PhoneVerificationComponent.prototype.keyPress = function (event) {
        var pattern = /[0-9]/;
        var phonel = this.fSendOTP.phone_number.value;
        var inputChar = String.fromCharCode(event.charCode);
        if ((event.keyCode !== 8 && !pattern.test(inputChar)) || phonel.length > 11) {
            event.preventDefault();
        }
        else {
            var countNumber = (this.fSendOTP.phone_number.value) ? phonel.length : 0;
            if (countNumber === 3 || countNumber === 7) {
                var phone_number = this.fSendOTP.phone_number.value + '-';
                this.fSendOTP['phone_number'].setValue(phone_number);
            }
        }
    };
    PhoneVerificationComponent.prototype.onSendOTPSubmit = function () {
        var _this = this;
        this.submitted = true;
        // stop here if form is invalid
        if (this.sendOTPForm.invalid) {
            return;
        }
        else {
            //Send OTP
            /**Add country code */
            var phone_number = '1%20' + this.sendOTPForm.value.phone_number.replace(/-/g, '');
            this.verifyOTPForm.controls['phone_number'].setValue(this.sendOTPForm.value.phone_number);
            this.spinner.show();
            this._appService.sendOTP(phone_number).subscribe(function (res) {
                _this.spinner.hide();
                _this.submitted = false;
                if (res && res.status != null) {
                    var alertClass = (res.status == 'success' || res.status == true) ? 'success' : 'danger';
                    _this._flashMessagesService.show(res.message, { cssClass: 'alert-' + alertClass, timeout: 10000, showCloseBtn: true });
                    if (res.status == 'success' || res.status == true) {
                        _this.otpSent = true;
                        _this.countDown = 60;
                        _this.getCountdown();
                    }
                }
            });
        }
    };
    PhoneVerificationComponent.prototype.onVerifyOTPSubmit = function () {
        var _this = this;
        this.submitted = true;
        // stop here if form is invalid
        if (this.verifyOTPForm.invalid) {
            return;
        }
        else {
            //Verify OTP
            /**Add country code */
            var phone_number = '1%20' + this.verifyOTPForm.value.phone_number.replace(/-/g, '');
            var otp = this.verifyOTPForm.value.otp;
            this.spinner.show();
            this._appService.verifyOTP(phone_number, otp).subscribe(function (res) {
                _this.submitted = false;
                _this.spinner.hide();
                if (res && res.status) {
                    var alertClass = (res.status == 'success') ? 'success' : 'danger';
                    _this._flashMessagesService.show(res.message, { cssClass: 'alert-' + alertClass, timeout: 10000, showCloseBtn: true });
                    if (res.status == 'success') {
                        setTimeout(function () {
                            //Close the popup after successful verification
                            _this.dialogRef.close({ verify_phone: 'Y', primary_number: _this.verifyOTPForm.value.phone_number });
                        }, 2000);
                    }
                }
            });
        }
    };
    PhoneVerificationComponent.prototype.getCountdown = function () {
        var _this = this;
        if (this.timer == null) {
            this.timer = setInterval(function () {
                _this.countDown--;
                if (_this.countDown == 0) {
                    _this.timer.clearInterval();
                    _this.timer = null;
                }
            }, 1000);
        }
    };
    PhoneVerificationComponent.prototype.editPhoneNumber = function () {
        this.submitted = false;
        this.otpSent = false;
        if (this.timer != null) {
            this.timer.clearInterval();
            this.countDown = 0;
            this.timer = null;
        }
    };
    return PhoneVerificationComponent;
}());
export { PhoneVerificationComponent };
